import React from "react";
import { Box } from "@mui/material";
import { useSelector } from 'react-redux';

export default function DefaultLogo({ firstName, lastName, mode = 'light' }) {
  const { user } = useSelector(state => ({ user: state.auth.user }));
  return (
    <Box id="defaultLogo" display="inherit" flexDirection="column" alignItems="center" justifyContent="center">
      <Box component="div" sx={{ fontFamily: 'Cormorant Garamond', color: mode === 'light' ? '#fff' : '#000', fontSize: '64px', fontWeight: '300', lineHeight: '0.75em', textAlign: 'center', textTransform: 'uppercase' }}>
        {firstName || user?.firstName}
      </Box>
      <Box component="div" sx={{ fontFamily: 'Cormorant Garamond', color: mode === 'light' ? '#fff' : '#000', fontSize: '64px', fontWeight: '300', lineHeight: '0.75em', textAlign: 'center', textTransform: 'uppercase' }}>
        {lastName || user?.lastName}
      </Box>
      <Box component="div" sx={{ fontFamily: 'Montserrat', color: mode === 'light' ? '#fff' : '#000', fontSize: '12px', fontWeight: '300', lineHeight: '16px', whiteSpace: 'nowrap', textAlign: 'center', marginTop: '10px', letterSpacing: '5px' }}>
        SENSUAL VIP COMPANION
      </Box>
    </Box>
  )
}
